import { lazyShowFullCompose } from 'owa-calendar-compose-form-store';
import {
    NEW_BUTTON_ANCHOR,
    NEW_BUTTON_RIBBON_ANCHOR,
} from 'owa-calendar-compose-form-view/lib/helpers/newButtonConstants';
import {
    ComposeFormType,
    FULL_COMPOSE_FORM_TYPE,
    QUICK_COMPOSE_FORM_TYPE,
    FULL_COMPOSE_VIEW_TYPE_MODAL,
} from 'owa-calendar-helpers-types/lib/ComposeTypes';
import { getUndoEntrySource } from '../utils/getUndoEntrySource';
import {
    CalendarNotificationBarCallbackReason,
    NotificationBarCallbackReason,
} from 'owa-calendar-notification-bar';
import {
    resetComposeStore,
    updateIsUndoNotificationShown,
} from 'owa-calendar-compose-form-actions';
import {
    QuickComposeEntrySourceType,
    FullComposeEntrySourceType,
    QUICK_COMPOSE_ENTRY_SOURCE_SURFACE,
} from 'owa-calendar-helpers-types/lib/ComposeMetricTypes';
import { tryShowQuickCompose } from 'owa-calendar-quick-compose/lib/actions/tryShowQuickCompose';
import EventScope from 'owa-service/lib/contract/EventScope';

export default function handleUndoNotificationCallback(
    callbackReason: CalendarNotificationBarCallbackReason,
    composeFormType: ComposeFormType,
    entrySource: QuickComposeEntrySourceType | FullComposeEntrySourceType,
    surfaceAnchor?: HTMLDivElement | string
) {
    if (callbackReason === NotificationBarCallbackReason.PrimaryActionClicked) {
        updateIsUndoNotificationShown(false);
        let anchor;
        switch (composeFormType) {
            case QUICK_COMPOSE_FORM_TYPE:
                // check if the surface anchor is valid, and if not, try anchoring to the new event button
                if (
                    surfaceAnchor instanceof HTMLDivElement &&
                    document.body.contains(surfaceAnchor)
                ) {
                    anchor = surfaceAnchor;
                } else if (
                    typeof surfaceAnchor === 'string' &&
                    document.querySelector(surfaceAnchor)
                ) {
                    anchor = surfaceAnchor;
                } else if (entrySource == QUICK_COMPOSE_ENTRY_SOURCE_SURFACE) {
                    if (document.querySelector(NEW_BUTTON_RIBBON_ANCHOR)) {
                        anchor = NEW_BUTTON_RIBBON_ANCHOR;
                    } else {
                        anchor = NEW_BUTTON_ANCHOR;
                    }
                }
                tryShowQuickCompose(
                    null /*CalendarEvent */,
                    getUndoEntrySource(
                        entrySource,
                        QUICK_COMPOSE_FORM_TYPE
                    ) as QuickComposeEntrySourceType,
                    EventScope.Default,
                    anchor
                );
                break;
            case FULL_COMPOSE_FORM_TYPE:
                lazyShowFullCompose.importAndExecute(
                    false,
                    getUndoEntrySource(
                        entrySource,
                        FULL_COMPOSE_FORM_TYPE
                    ) as FullComposeEntrySourceType,
                    FULL_COMPOSE_VIEW_TYPE_MODAL
                );
        }
    } else if (callbackReason == NotificationBarCallbackReason.AutoDismissed) {
        resetComposeStore(null /* formId */);
    }
}
